// extracted by mini-css-extract-plugin
export default {"LayoutPageWrapperPadding":"1.5rem","LayoutPageWrapperDesktopScreenBreakpointMin":"(min-width: 640px)","heading":"LoginPrompt_heading__IzaL6"};